export default "__VITE_ASSET__CVN5K5zh__"